<template>
  <operation-primary-header
    v-if="headerType === 'primary'"
    :link-text="linkText"
    :plain-text="plainText"
    :popover-title="popoverTitle"
    :links="links"
  />

  <operation-secondary-header
    v-else-if="headerType === 'secondary'"
    :plain-text="plainText"
    @goBack="emit('goBack')"
  />
</template>

<script setup>
import { defineProps } from 'vue'
import OperationPrimaryHeader from './OperationPrimaryHeader.vue'
import OperationSecondaryHeader from './OperationSecondaryHeader.vue'

defineProps({
  plainText: {
    type: [String, Object],
    default: '',
  },
  linkText: {
    type: [String, Object],
    default: '',
  },
  popoverTitle: {
    type: [String, Object],
    default: '',
  },
  links: {
    type: Array,
    default: () => [],
  },
  headerType: {
    type: String,
    default: 'primary', // primary, secondary
  },
})

const emit = defineEmits(['goBack'])
</script>
